import React from 'react'
import { Typography } from '@mui/material'
import tw from 'twin.macro'
import { ClientPublicWrapper } from 'src/components/layout/client/ClientPublicWrapper'
import { SignUpForm } from 'src/components/auth/sign-up-form/SignUpForm'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import { CLIENT_ROUTES } from 'src/constants/routes'
import { useQuery } from 'src/utils/hooks/useQuery'
import { ChevronRightMinor } from '@shopify/polaris-icons'
import { useSelector } from 'react-redux'
import { getPartnerPublicInfo } from 'src/selectors/partner'

export const ClientSignUpPage = () => {
  const navigate = useNavigate()
  const params = useParams()
  const { getQuery, getQueryAsArray } = useQuery()

  const partnerMarketId = getQuery('partnerMarketId')
  const onboardingTemplateId = getQuery('onboardingTemplateId')
  const phone = getQuery('phone')
  const email = getQuery('email')
  const firstName = getQuery('firstName')
  const lastName = getQuery('lastName')
  const referral = getQuery('referral')
  const initiatorId = getQuery('initiatorId')
  const tagNames = getQueryAsArray('tags') || []

  const partner = useSelector(getPartnerPublicInfo)

  const handleSuccess = (phone: string) => {
    navigate(`/client/${params.partnerName}/enter-code`, { state: { phone } })
  }

  const handleContinue = () => {
    navigate(`/client/${params.partnerName}/sign-in`, { state: { isContinue: true } })
  }

  if (!params?.partnerName || !partnerMarketId || !onboardingTemplateId) {
    return <Navigate to={CLIENT_ROUTES.NOT_FOUND_URL} />
  }

  return (
    <ClientPublicWrapper
      header={
        <div
          css={tw`w-full bg-primary-100 hover:bg-primary-200 flex flex-row justify-between items-center p-4 cursor-pointer`}
          onClick={handleContinue}
          data-testid="sign-in-sign-up-continue-banner"
        >
          <div>
            <Typography css={tw`text-primary-500`}>Already started onboarding?</Typography>
            <Typography css={tw`text-primary-500`} variant="h4">
              Tap to continue
            </Typography>
          </div>
          <ChevronRightMinor css={tw`fill-primary-500`} width={20} />
        </div>
      }
    >
      <Typography variant="h2" css={tw`mb-2 mt-4`}>
        {`Begin your onboarding${partner?.displayName ? ` with ${partner?.displayName}` : ''}`}
      </Typography>
      <Typography css={tw`mb-6 text-shades-400`}>
        You've been invited to onboard as an independent contractor. Please provide basic
        information to create an account and upload necessary documents for verification.
      </Typography>
      <SignUpForm
        partnerName={params.partnerName}
        phone={phone}
        email={email}
        firstName={firstName}
        lastName={lastName}
        referral={referral}
        partnerMarketId={partnerMarketId}
        onboardingTemplateId={onboardingTemplateId}
        initiatorId={initiatorId}
        tagNames={tagNames}
        onSuccess={handleSuccess}
      />
    </ClientPublicWrapper>
  )
}
